import { render, staticRenderFns } from "./AlertNotification.vue?vue&type=template&id=3f880a00"
import script from "./AlertNotification.vue?vue&type=script&lang=js"
export * from "./AlertNotification.vue?vue&type=script&lang=js"
import style0 from "./AlertNotification.vue?vue&type=style&index=0&id=3f880a00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports